import { useGetContractFamilyProjectionReadinessQuery } from "@/api/contract-families";
import { useGetSubcollectionsQuery } from "@/modules/snapshots/snapshotCollection.api";

interface Input {
  collectionId: string;
  subcollectionId: string | undefined;
  isContractFamilyProjection: boolean;
  collectionSnapshotCount: number | undefined;
}

/**
 * The sub-collection selected through `?subcollection_id=` with its display name and row count. Without one,
 * "All" counts the collection's snapshots, or the ready projected rows for a family summary projection.
 */
export const useActiveSubcollection = ({
  collectionId,
  subcollectionId,
  isContractFamilyProjection,
  collectionSnapshotCount,
}: Input) => {
  const { data: subcollections = [] } = useGetSubcollectionsQuery(
    {
      snapshot_collection_id: collectionId ?? "",
      contract_family_projection: isContractFamilyProjection,
    },
    { skip: !collectionId },
  );
  const projectionReadinessQuery = useGetContractFamilyProjectionReadinessQuery(collectionId ?? "", {
    skip: !collectionId || !isContractFamilyProjection,
  });
  const activeSubcollection = subcollectionId ? subcollections.find(s => s.id === subcollectionId) : undefined;
  const activeSubcollectionName = subcollectionId ? (activeSubcollection?.name ?? "Unknown") : "All";
  const activeSubcollectionCount = subcollectionId
    ? activeSubcollection?.member_count
    : isContractFamilyProjection
      ? projectionReadinessQuery.data?.ready_count
      : collectionSnapshotCount;

  return {
    activeSubcollection,
    activeSubcollectionName,
    activeSubcollectionCount,
    projectionReadiness: projectionReadinessQuery.data,
  };
};
